<!-- Upload in progress -->
<li class="upload-uploading-state">
  <!-- Uploading Animation and Visual -->
  <i
    [hidden]="!isFailureHidden() || !isUploadSuccessHidden()"
    class="uploading"
  >
    <svg width="42px" height="42px">
      <g>
        <circle cx="21" cy="21" r="18px" />
        <circle
          cx="21"
          cy="21"
          r="18px"
          [ngStyle]="{ strokeDashoffset: 100 - uploadFile.progress * 100 }"
        />
      </g>
    </svg>
    <span>{{ formatProgress() }}</span>
  </i>

  <!-- Upload Success SVG Visual -->
  <i [hidden]="isUploadSuccessHidden()" class="upload-success">
    <svg width="42px" height="42px">
      <g>
        <circle cx="21" cy="21" r="18px" />
        <circle cx="21" cy="21" r="18px" />
      </g>
    </svg>
  </i>

  <!-- Upload Failure SVG Visual -->
  <i [hidden]="isFailureHidden()" class="upload-failure">
    <svg>
      <path
        cx="21"
        cy="21"
        fill-rule="evenodd"
        d="M1.097,37.062 L21.681,1.269 C22.428,-0.029 24.294,-0.029 25.041,1.269 L45.625,37.062 C46.371,38.360 45.438,39.983 43.945,39.983 L2.777,39.983 C1.284,39.983 0.351,38.360 1.097,37.062 ZM24.774,18.970 L22.795,18.970 L22.795,20.958 L24.774,20.958 L24.774,18.970 ZM24.774,29.901 L24.774,22.946 L22.795,22.946 L22.795,29.901 L21.804,29.901 L21.804,30.895 L25.764,30.895 L25.764,29.901 L24.774,29.901 Z"
      />
    </svg>
  </i>

  <span>{{ uploadFile.file.name }}</span>
  <span class="analyzing" [hidden]="isUploadSuccessHidden()">Analyzing..</span>
  <button (click)="onRemove()">
    <svg>
      <path
        fill-rule="evenodd"
        d="M10.971,9.921 L9.916,10.976 L5.967,7.026 L2.018,10.976 L0.963,9.921 L4.912,5.971 L0.963,2.022 L2.018,0.967 L5.967,4.916 L9.916,0.967 L10.971,2.022 L7.022,5.971 L10.971,9.921 Z"
      />
    </svg>
  </button>

  <span [hidden]="isFailureHidden()" class="offline-indicator">
    <a href="#" (click)="uploadFailedReport($event)" [hidden]="!reportCta">{{
      reportCta
    }}</a>
  </span>
</li>
